import React, { useEffect } from 'react';
import { fieldToLabel } from './fieldNameToThings';
import { RouteComponentProps } from 'react-router-dom';
import { EditTransactionContainer } from './EditTransactionContainer';
import { routeNames } from 'utilities/order/formConfig';

interface IEditTransactionPriceRouterContainerProps extends RouteComponentProps<{ field: string }> {
  onClose?: () => void;
  loadOrder?: () => Promise<void>;
}

export const EditTransactionRoute: React.FC<IEditTransactionPriceRouterContainerProps> = ({
  match: {
    params: { field },
  },
  ...props
}) => {
  useEffect(() => {
    if (props.onClose === undefined) {
      document.title = `Order Overview: ${fieldToLabel[field]} - Spruce`;
    }
  }, [field, props.onClose]);

  return <EditTransactionContainer {...props} field={field as routeNames} />;
};
